module.exports = __webpack_public_path__ + "img/hailangOffiicial.fc178491.jpg";